module.exports = __webpack_public_path__ + "static/img/3.3d33a33.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/sp/3.png
// module id = RK8i
// module chunks = 0